import React from "react";
import { CircularProgress } from "@material-ui/core";

const LoadingScreen: React.FC = () => {
  return (
    <div
      style={{
        minWidth: "100vw",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1 style={{ marginRight: 15 }}>Uverify</h1>
      <CircularProgress />
    </div>
  );
};

export default LoadingScreen;
